export default {
  ID() {
    return '_' + Math.random().toString(36).substr(2, 9);
  },

  focusElement(id) {
    setTimeout(function () {
      const el = document.getElementById(id);
      if (el) {
        el.focus();
      }
    }, 100);
  },

  focusrElement(id) {
    setTimeout(function () {
      const el = document.getElementById(id);
      if (el) {
        el.focus();
      }
    }, 100);
  },

  scrollTo(id) {
    const el = document.getElementById(id);

    if (el) {
      el.scrollIntoView();
    }
  },

  isMobile() {
    return /iPhone|iPad|iPod|Android/i.test(navigator.userAgent)
  },

  base_url(vue, empresa) {
    return vue.server + empresa.token + '/'
  },

  getIdsSacola(dados) {
    if (!dados || !dados.produtos) {
      return;
    }

    let tabelas = [];
    const produtos = dados.produtos;

    produtos.forEach(p => {
      if (p.adicionais && p.adicionais.length) {
        tabelas = tabelas.concat(p.adicionais.map(a => a.id_tabela_preco));
      }

      if (p.divisoes && p.divisoes.length) {
        tabelas = tabelas.concat(p.divisoes.map(d => d.id_tabela_preco));
      }

      tabelas.push(p.produto.id_tabela_preco);
    });

    return tabelas;
  },

  parseJSONObject(jsonString){
    if (jsonString) {
      try {
        const o = JSON.parse(jsonString);
        if (o && typeof o === "object") {
          return o;
        }
      }
      catch (e) { }
    }

    return false;
  },

  validarCpf(cpf) {
    if (typeof cpf !== 'string') return false
    cpf = cpf.replace(/[^\d]+/g, '')
    if (cpf.length !== 11 || !!cpf.match(/(\d)\1{10}/)) return false
    cpf = cpf.split('').map(el => +el)
    const rest = (count) => (cpf.slice(0, count-12)
      .reduce( (soma, el, index) => (soma + el * (count-index)), 0 )*10) % 11 % 10
    return rest(10) === cpf[9] && rest(11) === cpf[10]
  },

  validarAniversario(data) {
    if (!data || !/^\d{8}$/.test(data)) return null;
    let dia = parseInt(data.substring(0, 2), 10);
    let mes = parseInt(data.substring(2, 4), 10);
    let ano = parseInt(data.substring(4, 8), 10);
    let dataObj = new Date(ano, mes - 1, dia);
    if (dataObj.getFullYear() !== ano || dataObj.getMonth() + 1 !== mes || dataObj.getDate() !== dia) return null;
    return `${ano}-${String(mes).padStart(2, '0')}-${String(dia).padStart(2, '0')}`;
  },

  getCardapioEmpresa(vue, token, tipo_pedido, callback) {
    vue.$http.get(token + '/categorias', { params: {tipo_pedido} })
      .then(response => {
        vue.$store.state.cardapio = response.data;

        if (callback) {
          callback(true);
        }

      }, res => {
        vue.$swal('Não conseguimos atualizar o cardápio do aplicativo, por favor recarregue a página.');

        if (callback) {
          callback(false);
        }
      });
  },

  setEmpresaStatus(vue, empresa, callback) {
    vue.$http.get(empresa.token + '/empresa/status')
      .then(response => {
        if (response.data) {
          const empresaStatus = response.data;
          empresa.ativo = empresaStatus.ativo;
          empresa.pausa_programada = empresaStatus.titulo_pausa;
          empresa.aberto = empresaStatus.aberto;
          empresa.tipo_delivery = empresaStatus.tipo_delivery;
          empresa.entregas = empresaStatus.entregas || [];
          empresa.proximo_horario = empresaStatus.proximo_horario;
          empresa.server = vue.server;
          const agendamento = empresa.entrega_agendada === '1' && (!!empresa.entregas.length || parseInt(empresa.json_config.agendamento_maximo || '0') > 0);
          empresa.empresaAberta = empresa.ativo === '1' && (empresa.aberto === '1' || agendamento);
          vue.$store.commit('setEmpresa', empresa);
          callback(empresa);

        } else {
          callback(null);
        }

      }, res => {
        callback(null);
        vue.$swal('Não conseguimos buscar o status da empresa, por favor recarregue a página.');
      });
  },

  trackPixel(vue, event, empresa, force, data) {
    if (!sessionStorage.getItem(event)) {
      const event_id = 'evt_' + Math.random().toString(36).substr(2, 9) + '_' + Date.now();

      if (typeof fbq === 'function') {
        if (data) {
          fbq('track', event, data, { eventID: event_id });

        } else {
          fbq('track', event, { eventID: event_id });
        }
      }

      if ((empresa.integracoes || []).includes('10')) {
        const url_server = this.base_url(vue, empresa) + "/evento";
        const dados = { event_id, event_name: event, event_source_url: window.location.host, ...(data || {}) }
        vue.$http.post(url_server, dados);
      }

      if (!force) {
        sessionStorage.setItem(event, 'true');
      }
    }
  },

  configGoogleTag(vue) {
    if (typeof gtag === 'function') {
      const tag = (vue.$store.state.empresa.gtags || []).find(g => g.tipo_tag === '1');

      if (tag) {
        gtag('config', tag.codigo_tag);
      }
    }
  },

  googleTag(vue, codigo, valor) {
    if (typeof gtag === 'function' && codigo && !sessionStorage.getItem(`GTag${codigo}`)) {
      const gtags = vue.$store.state.empresa.gtags || [];
      const tag = gtags ? gtags.find(g => g.tipo_tag === codigo) : null;

      if (tag) {
        sessionStorage.setItem(`GTag${codigo}`, 'true');
        const data = valor ? { 'send_to': tag.codigo_tag, 'value': valor, 'currency': 'BRL' } : { 'send_to': tag.codigo_tag };
        gtag('event', 'conversion', data);
      }
    }
  },

  trackAnalytics(event, data) {
    if (typeof gtag === 'function' && event && !sessionStorage.getItem(event)) {
      sessionStorage.setItem(event, 'true');
      gtag("event", event, data);
    }
  },

  imprimir(vue, nome_documento, content, callback) {
    const printConfig = JSON.parse(vue.$store.state.dataSistema.printConfig || '{}');
    const device = printConfig.devicePdv || null;
    const dataImpressao = {
      content,
      copies: 1,
      isPdv: true,
      status: 1,
      nome_documento,
      device,
      impressora: {
        device,
        zoom: printConfig.zoom || "9px",
        largura: printConfig.largura || '100%'
      }
    };

    vue.$http.post(vue.base_server + 'api/pdv/impressao/' + localStorage.getItem('key'), { dataPedidos: [dataImpressao], socket: true })
      .then(res => {
        if (res.data && res.data.id_impressao) {
          callback(true);

        } else {
          callback(false);
        }

      }, res => {
        callback(false);
        vue.$swal(res.data.msg ? res.data.msg : "Erro temporário");
      });
  },

  chamarGarcom(vue) {
    const nolocal = vue.$store.state.nolocal;

    vue.$swal({
      text: "Deseja chamar o garçom?",
      buttons: ["Cancelar", "Sim"],
      dangerMode: true
    }).then((result) => {
      if (result) {
        vue.$store.state.load = "Só um momento..";
        const local = `${nolocal.onde_estou + ' ' + (nolocal.obs_pedido || '')}`;
        const content = `<div style="border: 2px dashed #000;padding: 40px 0;text-align: center;width: 100%;page-break-inside: avoid;">
                         <div><b>Atendimento solicitado</b></div>
                         <div style="margin-bottom: 22px">Por favor, encaminhar um garçom.</div>
                         <div style="font-size: 28px; font-weight: bold; text-transform: uppercase">${local}</div>
                         </div></br></br>-`;
        this.imprimir(vue, `Solicitação Garçom: ${local}`, content, (res) => {
          vue.$store.state.load = false;

          if (res) {
            vue.$router.push('/confirmado#3');

          } else {
            vue.$swal('Erro ao chamar o garçom.');
          }
        })
      }
    });
  },
};
